import { SdsWebApi } from "../generated/apis/SdsWebApi";
import { Configuration, ConfigurationParameters } from "../generated/runtime";
import { getRouterBasename } from "../../utilities/navigationUtils";
import Constants from "../../constants";

function resolveApiBasePath(): string {
    const fromQuery = new URLSearchParams(window.location.search).get(Constants.serviceUrlQueryParam);
    if (fromQuery) {
        return fromQuery.replace(/\/+$/, "");
    }
    const pathBase = getRouterBasename(window.location.pathname).replace(/\/$/, "");
    return `${window.location.origin}${pathBase}`;
}

const configurationParameters: ConfigurationParameters = {
    get basePath(): string {
        return resolveApiBasePath();
    },
};

export const configuration = new Configuration(configurationParameters);
const client = new SdsWebApi(configuration);

export default client;
